<template>
  <div class="chart-container">
    <div class="mx-3 my-3 d-flex gap-8">
      <div class="theme-color-seven">คะแนนประเมิน</div>
      <div>{{ calculateAVG(masterData)+" %" }}</div>
    </div>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);

export default {
  name: "spiderChart",
  data() {
    return {
      chartOptions: {
        chart: {
          polar: true,
          type: "area",
          backgroundColor: "#ffffff", // สีพื้นหลังกราฟ
          animation: {
            duration: 300
          },
          // ปรับปรุง event handling
          events: {
            load: function() {
              // เพิ่ม event listener สำหรับ hover
              const chart = this;
              chart.series[0].points.forEach(function(point) {
                point.graphic.css({
                  'cursor': 'pointer'
                });
              });
            }
          }
        },
        title: {
          text: "",
          useHTML: true,
          align: "left",
          x: 0,
          style: {
            fontSize: "16px",
            fontFamily: "Arial, sans-serif",
          },
        },
        pane: {
          size: "80%",
        },
        xAxis: {
          categories: [],
          tickmarkPlacement: "on",
          lineWidth: 0,
          labels: {
            enabled: true,
            style: {
              color: "#666",
              fontSize: "11px",
              width: "150px",
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'   
            },
            formatter: function() {
              // จำกัดความยาวของข้อความใน label
              const maxLength = 30; // จำกัดที่ 30 ตัวอักษร
              if (this.value && this.value.length > maxLength) {
                return  this.value.substring(0, maxLength) + '...';
              }
              return this.value;
            },
            useHTML: true,
          },
        },
        yAxis: {
          gridLineInterpolation: "polygon",
          lineWidth: 0,
          min: 0,
          tickmarkPlacement: "on",
          tickInterval: 20,
          labels: {
            enabled: false,
            style: {
              color: "#888",
              fontSize: "12px",
            },
          },
          gridLineColor: "var(--theme-color-nine)", // สีเส้นกริด
        },
        plotOptions: {
          line: {
            color: "var(--theme-color-seven)", // สีเส้นกราฟ
            fillOpacity: 0.3,
            lineWidth: 0,
            marker: {
              fillColor: "var(--theme-color-seven)", // สีจุด marker
              lineWidth: 0,
              radius: 3,
            },
          },
          series: {
            pointPlacement: "on",
            color: "#F15A29",
            fillColor: "rgba(255, 87, 51, 0.3)",
            marker: {
              symbol: "circle",
              radius: 4, // เพิ่มขนาด marker
              fillColor: "#FF5733",
              lineWidth: 1,
              lineColor: "#FF5733",
              states: {
                hover: {
                  radius: 6, // ขนาดเมื่อ hover
                  lineWidth: 2,
                  fillColor: "#FF3300"
                }
              }
            },
            lineWidth: 1,
            states: {
              hover: {
                marker: {
                  enabled: true
                }
              }
            },
            point: {
              events: {
                mouseOver: function() {
                  // เพิ่ม highlight เมื่อ mouse over
                  this.graphic.attr({
                    fill: '#FF3300',
                    'stroke-width': 2
                  });
                },
                mouseOut: function() {
                  // กลับสีเดิมเมื่อ mouse out
                  this.graphic.attr({
                    fill: '#FF5733',
                    'stroke-width': 1
                  });
                }
              }
            },
            stickyTracking: false, // ปิด sticky tracking เพื่อให้แม่นยำขึ้น
            trackByArea: false // ไม่ให้ track ตาม area
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: 'คะแนน: {point.y}<br/>',
          shared: false,
          useHTML: true,
          style: {
            fontSize: '12px'
          },
          followPointer: false,
          stickOnContact: true,
          distance: 30,
          hideDelay: 100
        },

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                title: {
                  x: 0,
                },
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                pane: {
                  size: "70%",
                },
              },
            },
          ],
        },
      },
    };
  },
  props: {
    masterData: Object,
  },
  components: {
    highcharts: Chart,
  },
  watch: {
    masterData: {
      handler(val) {
        this.getData();
      },
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    calculateAVG(data) {
      let arr = data?.chart_data?.series[0]?.data || []
      let max = data?.chart_data?.yAxis?.max
      let total = 0
      for (let i = 0 ; i < arr.length; i++) {
        total += arr[i]
      }
      return ((total/arr.length) / max * 100).toFixed(2)
    },
    async getData() {
      this.chartOptions.series = [
        {
          ...this.chartOptions.series,
          data: this.masterData?.chart_data?.series[0]?.data,
          name: this.masterData?.chart_data?.series[0]?.name,
        },
      ];
      console.log(this.chartOptions.series, "here");
      this.chartOptions.xAxis.categories =
          this.masterData?.chart_data?.xAxis?.categories || [];
      this.chartOptions.yAxis.max = this.masterData?.chart_data?.yAxis?.max || 0;
      this.chartOptions.yAxis.tickInterval =
          this.masterData?.chart_data?.yAxis?.max / 5;

      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.highcharts-figure,
.highcharts-data-table table {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 500px;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.highcharts-description {
  margin: 0.3rem 10px;
}

.chart-container {
  border: 1px solid var(--theme-color-eight);
  border-radius: 10px;
  padding: 10px;
  background-color: #ffffff;
}
</style>
